import { useItemStyles } from '../../hooks/useItemStyles';
import { EditorItem } from '../../store/editorStore';

interface AITextItemContentProps {
  item: EditorItem;
}

export function AITextItemContent({ item }: AITextItemContentProps) {
  const { createContainerStyle, createTextareaStyle, createTextStyle } = useItemStyles();
  
  const style = item.style as any;
  const containerStyle = createContainerStyle(style);
  const textareaStyle = createTextareaStyle(style); 
  const textStyle = createTextStyle(style);

  return (
    <div style={containerStyle}>
      <div style={textStyle}>
        {`<<nội dung ai tự tạo>>`}
      </div>
    </div>
  );
} 